module.exports = __webpack_public_path__ + "img/hero_sp.d0fedffc.jpg";